import styles from './User.module.css'
import { useState } from "react"
import { Row, Col } from "react-bootstrap"
import Checkbox from '../../../../../components/checkbox/Checkbox'
import { modifyUserData } from '../users-list/VpnUsers'
import DefaultButton from '../../../../../components/buttons/default-button/DefaultButton'
import QrButton from '../../../../../components/buttons/qr-button/QrButton'
import Uuid from '../../../../../components/uuid/Uuid'
import UidModal from './UidModal'
import QrModal from './QrModal'

export type VpnUserType = {
    id: number
    username: string
    rtrComment: string
    totpSecret: string
    totpSecretDataUrl: string
    enabled: boolean
}

interface userPropsInterface {
    odd: boolean
    user: VpnUserType
    modifyUser: (userId: number, data: modifyUserData) => Promise<void>
}

export default function User({ odd, user, modifyUser }: userPropsInterface) {
    const [ showUuidModal, setShowUuidModal ] = useState(false)
    const [ showQrModal, setShowQrModal ] = useState(false)
    
    return (
        <>
            <Row style={odd ? {backgroundColor: "rgb(0, 0, 0, 0.1)"} : {backgroundColor: "rgb(0, 0, 0, 0.3)"} } className={styles.containerBody}>

                <Col sm="2">{user.id}</Col>

                <Col sm="2">{user.username}</Col>

                <Col sm="2" style={{textAlign:"center"}}>
                    <Uuid click={setShowUuidModal}/>
                </Col>

                <Col sm="2">
                    <DefaultButton title={'Új Seed'} onClick={e => {
                            e.preventDefault()

                            modifyUser(user.id, {
                                generateTotpSeed: true
                            })
                        }
                    }/>
                </Col>

                <Col sm="2" style={{justifyItems:"center"}}>
                    <Checkbox
                        id={ `user-${ user.id }-enabled` }
                        name='enabled'
                        checked={ user.enabled }
                        onChange={ e => {
                            e.preventDefault()

                            const enabled = e.target.checked
                            modifyUser(user.id, { enabled })
                        }}
                    />
                </Col>

                <Col sm="2">
                    <QrButton onClick={e => {
                            e.preventDefault()

                            setShowQrModal(true)
                        }
                    } />
                </Col>
            </Row>

            <QrModal
                visible={showQrModal}
                onHide={() => setShowQrModal(false)}
                userId={user.id}
                username={user.username}
                totpSecretDataUrl={user.totpSecretDataUrl}
            />

            <UidModal
                visible={showUuidModal}
                onHide={() => setShowUuidModal(false)}
                username={user.username}
                rtrComment={user.rtrComment}
                reGenerateUUID={() => {
                    modifyUser(user.id, {
                        generateUUID: true
                    })
                }}
            />
        </>
    )
}